module.exports = __webpack_public_path__ + "media/Video-for-animation-2.d0a35578.mp4";